<template>
  <div class="payment-container">
      <div v-if="isSupportHurdle && openType!=='popup'" class="support-hurdle"></div>
      <page-title :title="gettext('支付方式')"></page-title>
      <main>
        <div class="add-card">
          <span class="icon-add"></span>
          <div class="add-card-content">
            <p class="add-card-title" @click="addCard">{{gettext('添加信用卡/借记卡')}}</p>
            <p class="add-card-text">{{gettext('卡类型')}}</p>
          </div>
        </div>
        <div :class="'card-list ' + (card.isDisable ? 'card-disabled' : '')" v-for="card in extraInfoList" :key="card.card_index" @click="handleClick(card)">
          <img :src="card.card_org" class="icon-card" alt="" />
          <div v-if="!card.isDisable" class="card-info">{{card.card_suffix | cardFilter}}</div>
          <span v-if="!card.isDisable" :class="[selectedMent.card_index === card.card_index ? 'radio-checked': 'radio-no-checked']"></span>
          <div class="disable-payment-content" v-if="card.isDisable">
            <p class="title">{{ card.card_suffix }}</p>
            <p class="text">{{ card.disableReason }}</p>
          </div>
        </div>
        <div class="cash-payment">
          <span class="icon-cash"></span>
          <div class="cash-payment-content">
            <p class="cash-title">{{gettext('现金')}}</p>
            <p class="cash-text">{{gettext('不支持现金支付')}}</p>
          </div>
          <span class="radio-no-checked"></span>
        </div>
      </main>
      <footer>
        <div class="btn-wrap">
          <rich-button 
            :loading="loading" 
            @click.native="confirm"
            >
            {{gettext('确定')}}
          </rich-button>
        </div>
      </footer>
  </div>
</template>
<script>
import PageTitle from './modules/page-title'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'payment',
  props: ['openType'],
  components: {
    PageTitle
  },
  data () {
    return {
      selectedMent: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters(['globalParams', 'selectedCard']),
    extraInfoList () {
      return this.$store.state.extraInfoList
    },
    // 是否支持沉浸式
    isSupportHurdle () {
      return this.$store.state.isSupportHurdle
    }
  },
  filters: {
    // 取卡号后4位
    cardFilter (card) {
      return String(card).slice(-4) || ''
    }
  },
  async created () {
    this.selectedMent = this.selectedCard
  },
  methods: {
    ...mapActions({
      getPayInfo: 'getPayInfo',
      setPayment: 'setPayment'
    }),
    addCard () {
      // 吊起添加卡片bridge
      // bindCard
      this.SodaBridge('customer.bindCard', {}).then(({ data }) => {
        // statusCode: 1.绑卡成功 2.绑卡失败 3. 用户取消
        if (data && data.statusCode) {
          let toast = this.$createToast({
            txt: data.statusMsg || this.gettext('网络异常，请稍后再试'),
            time: 2000,
            mask: false,
            type: 'error'
          })
          toast.show()
        } else {
          // 重新获取卡信息
          this.getPayInfo({
            ...this.globalParams
          })
        }
      })
    },
    handleClick (card) {
      if (card && !card.isDisable) {
        this.selectedMent = card
      }
    },
    confirm () {
      this.loading = true
      this.setPayment(this.selectedMent)
      this.loading = false
      if (this.openType === 'popup') {
        // 关闭弹窗
        this.$emit('close-popup')
        return
      }
      // 返回上一页
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/common/stylus/main'
@import '~@/common/stylus/variables'
.support-hurdle{
  height:160px;
}
.payment-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: #fff;
  .icon-close {
    width: 32px;
    height: 32px;
    background-image: url('~@/assets/images/common/close.png')
    background-size: 100% 100%;
    position:absolute;
    top: 60px;
    left: 44px;
  }
  main {
    padding-left: 40px;
    .add-card {
      display: flex;
      align-items: center;
      height: 120px;
      .icon-add {
        width: 48px;
        height: 48px;
        background-image: url('~@/assets/images/c/add-icon.png')
        background-size: 100% 100%;
      }
      .add-card-content {
        margin-left: 3.7%;
      }
      .add-card-title {
        font-family: Helvetica;
        font-size: 32px;
        line-height: 38px;
        color: #000;
      }
      .add-card-text {
        opacity: 0.96;
        font-family: Helvetica;
        font-size: 24px;
        line-height: 29px;
        color: #999;
      }
    }
    .card-list {
      position: relative;
      display: flex;
      align-items: center;
      border-top: 1px solid #f5f5f5;
      height: 120px;
      span {
        display: inline-block;
      }
      .icon-card {
        margin-right: 32px;
        width: 48px;
        height: 38px;
        border: 1px solid #DDDDDD;
        border-radius: 3px;
      }
      .card-info {
        font-size: 32px;
        color: #000;
        line-height: 32px;
      }
      .disable-payment-content {
        width: 70%;
        span {
          display: inline-block;
        }
        .title {
          font-size: 32px;
          line-height: 45px;
          color: #999;
        }
        .text {
          opacity: 0.96;
          font-size: 24px;
          color: #999;
          line-height: 28px;
        }
      }
    }
    .card-disabled {
      height: auto;
      padding: 10px 0 18px;
      .icon-card {
        opacity: 0.3;
      }
    }
    .cash-payment-content {
      width: 70%
    }
    .radio-checked {
      position: absolute;
      right: 40px;
      width: 40px;
      height: 40px;
      icon-checked-card();
    }
    .radio-no-checked {
      position: absolute;
      right: 40px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 2px solid #CCC;
    }
    .cash-payment {
      position: relative;
      display: flex;
      align-items: center;
      border-top: 1px solid #f5f5f5;
      height: 150px;
      span {
        display: inline-block;
      }
      .icon-cash {
        margin-right: 32px;
        width: 48px;
        height: 30px;
        border: 1px solid #DDDDDD;
        border-radius: 3px;
        background-image: url('~@/assets/images/c/ic-PayPal.png')
        background-size: 100% 100%;
      }
      .cash-title {
        font-size: 32px;
        line-height: 45px;
        color: #999;
      }
      .cash-text {
        opacity: 0.96;
        font-size: 24px;
        color: #999;
        line-height: 28px;
      }
    }
  }
  footer {
    position: fixed;
    width: 100%;
    bottom: 52px;
    .btn-wrap {
      margin: 0 40px 0;
      height: 90px;
      line-height: 90px;
    }
  }
}
</style>